import { ApiClient } from "../ApiClient";

/**
 * Send referral invitations via email
 * @param {Object} data - Payload containing email list and message
 * @returns {Promise<Response>}
 */
export const sendReferralInvitations = async (data) => {
  // ApiClient.post handles baseUrl, CSRF, and JSON stringification
  return ApiClient.post("/referral/send-email-referrals", data);
};

/**
 * Generate a new referral code
 * @param {Object} data - Payload with service type or other code details
 * @returns {Promise<Response>}
 */
export const generateReferralCode = async (data) => {
  return ApiClient.post("/referral/referral-code", data);
};

/**
 * Log a new referral conversion
 * @param {Object} data - Payload identifying the referred user/action
 * @returns {Promise<Response>}
 */
export const createReferralConversion = async (data) => {
  return ApiClient.post("/referral/conversion-referral", data);
};

/**
 * Fetch aggregated referral conversion data
 * @param {string} url - Dynamic endpoint path for reporting
 * @returns {Promise<Response>}
 */
export const getAggregatedReferralConversions = async (url) => {
  // ApiClient.get handles the dynamic URL and standard headers
  return ApiClient.get(url);
};
